// stores/counter.js
import { defineStore } from 'pinia'

import { ref } from "vue";

export const useSalidaStore = defineStore('salida', () => {
  

  const horarios = ref(["07:30", "09:00", "17:00"])
  const conductores = ref([])

  const list = ref({
    data: []
  })
  const history = ref([])

  const addSalida = (form) => {

    list.value.data.push(form)
  }

  // console.log("useSalidaStore", list.value)
  return {
    horarios,
    conductores,
    list,
    addSalida,
    history,
  }
})
